import { POOL_API_TO_POOL_ID_MAP } from '../enterprise';
import { OnBehalfProjectAjax } from './on-behalf-projects.backend-model';
import { OnBehalfProject } from './on-behalf-projects.model';

export function transformOnBehalfProjects(
  onBehalfProject: OnBehalfProjectAjax,
): OnBehalfProject {
  return {
    ...onBehalfProject,
    // Handle the case where pool IDs are an integer, but also the case where
    // they are strings, to maintain forwards and backwards compatibility.
    // TODO: Cleanup T221545
    poolIds: onBehalfProject.poolIds.map(id =>
      typeof id === 'string' ? POOL_API_TO_POOL_ID_MAP[id] : id,
    ),
  };
}
